import axios from 'axios';
import axiosInstance from '../../../_utils/axiosConfig';

let Hebergement : any = {};
Hebergement.submitForm = async (data:any) =>{
    return await axios.post(`${process.env.REACT_APP_BASE_URL}/api/hebergement/edit`, data)
}

Hebergement.verifyForm = async(data:any)=>{
    return await axiosInstance.post(`${process.env.REACT_APP_BASE_URL}/api/hebergement/verify`,data);
}

Hebergement.getOne = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/hebergement/show/${id}`)
}

Hebergement.getImages = async (id:any) =>{
    return await axios.get(`${process.env.REACT_APP_BASE_URL}/api/hebergement/images/${id}`)
}

export default Hebergement;